import React, { useState } from 'react';
import useForm from '../hooks/useForm';

const Contact = ({ showToast = console.log }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { handleChange, handleSubmit, errors, values } = useForm({
    initialValues: { name: '', email: '', message: '' },
    onSubmit: (values) => {
      setIsSubmitting(true);
      try {
        // Build the mailto link
        const subject = `New Message from ${values.name}`;
        const body = `Name: ${values.name}%0D%0AEmail: ${values.email}%0D%0A%0D%0AMessage:%0D%0A${values.message}`;
        
        // Open default email client
        window.location.href = `mailto:studiodashweb@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        
        showToast('Your email client is opening with the message ready to send!', 'success');
      } catch (error) {
        console.error(error);
        showToast('Failed to open email client. Please try again.', 'error');
      } finally {
        setIsSubmitting(false);
      }
    },
    validate: (values) => {
      const errors = {};
      if (!values.name) errors.name = 'Name is required';
      if (!values.email) errors.email = 'Email is required';
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) errors.email = 'Email is invalid';
      if (!values.message) errors.message = 'Message is required';
      return errors;
    }
  });

  return (
    <section className="contact" id="contact">
      <div className="page-title in-view">
        <h2>Let's Discuss Your Project</h2>
      </div>
      <form className="contact__form fade-in" onSubmit={handleSubmit}>
        <input
          type="text"
          className="input-element"
          name="name"
          placeholder="Full Name"
          value={values.name}
          onChange={handleChange}
        />
        {errors.name && <p className="error-message">{errors.name}</p>}

        <input
          type="email"
          className="input-element"
          name="email"
          placeholder="Email Address"
          value={values.email}
          onChange={handleChange}
        />
        {errors.email && <p className="error-message">{errors.email}</p>}

        <textarea
          className="input-element"
          name="message"
          rows="5"
          placeholder="Your Project Details"
          value={values.message}
          onChange={handleChange}
        ></textarea>
        {errors.message && <p className="error-message">{errors.message}</p>}

        <button type="submit" className="button" disabled={isSubmitting}>
          {isSubmitting ? 'Preparing Email...' : 'Send Message'}
        </button>
      </form>
    </section>
  );
};

export default Contact;
